import React from 'react';
import { LoaderType } from 'common/components/Loader/types';
import { Loader } from 'common/components/Loader';

export const DotsLoader = () => (
    <Loader
        isLoading={true}
        viewBox="0 0 400 160"
        height={98}
        width={280}
        speed={1.5}
        backgroundColor="#ecebeb"
        foregroundColor="#cccccc"
        loaderType={LoaderType.CUSTOM_SVG}
        render={() => (
            <>
                <circle cx="150" cy="86" r="12" />
                <circle cx="194" cy="86" r="12" />
                <circle cx="238" cy="86" r="12" />
            </>
        )}
    />
);

export const RadioLoader = () => (
    <Loader
        isLoading={true}
        speed={2}
        height={150}
        viewBox="0 0 800 300"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        loaderType={LoaderType.CUSTOM_SVG}
        render={() => (
            <>
                <rect x="114" y="17" rx="6" ry="6" width="483" height="20" />
                <circle cx="24" cy="28" r="24" />
                <rect x="116" y="97" rx="6" ry="6" width="400" height="20" />
                <circle cx="24" cy="108" r="24" />
                <rect x="115" y="177" rx="6" ry="6" width="453" height="20" />
                <circle cx="24" cy="188" r="24" />
                <rect x="117" y="257" rx="6" ry="6" width="440" height="20" />
                <circle cx="24" cy="268" r="24" />
            </>
        )}
    />
);
